import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getList } from "actions/scooter/battery/actions";

import CommonTable from "views/lib/components/CommonTable";

import Filers from "./filters";

const Scooter = ({
                   list,
                   getList,
                 }) => {
  const getColumns = () => [
    {
      id: "bar",
      Header: "Bar",
      accessor: "bar",
    },
    {
      id: "status",
      Header: "Status",
      accessor: "status",
    },
  ];

  return (
    <CommonTable
      columns={getColumns()}
      list={list}
      getListFunction={getList}
      FiltersComponent={Filers}
      searchHookProps={{
        size: 20,
        sort: "status,asc"
      }}
    />
  );
};

const mapStateToProps = state => ({
  list: state.scooterBattery.list,
});

const mapStateToDispatch = dispatch => ({
  getList: bindActionCreators(getList, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(Scooter);



// WEBPACK FOOTER //
// ./src/views/pages/scooter/battery/index.js